import React, { useRef, useState, useEffect } from "react";
import Navigation from "@/scenes/_shared/navigation";
import { useStateContext } from "@/components/state";

const Form = ({ pages, next }) => {
    const formRef = useRef();
    const { state, dispatch } = useStateContext();
    const [height, setHeight] = useState(null);

    const setHeader = (value) => {
        dispatch({ scenes: { header: value } });
    };

    // Observe form height changes
    useEffect(() => {
        const node = formRef.current;
        if (!node) return;

        const updateHeight = () => {
            setHeight(node.offsetHeight);
        };

        updateHeight(); // initial

        const observer = new ResizeObserver(updateHeight);
        observer.observe(node);

        return () => observer.disconnect();
    }, []);

    return (
        <form onSubmit={next} ref={formRef}>
            <div className="form__pages" style={{ height: `${height ?? 0}px` }}>
                {pages?.map((Component, index) => (
                    <Component
                        key={index}
                        disabled={state?.scenes?.current !== index + 1}
                        bodyHeight={height}
                        setHeight={setHeight}
                        setHeader={setHeader}
                    />
                ))}
            </div>

            <Navigation next={next} formRef={formRef} />
        </form>
    );
};

export default Form;
